import request from "@/utils/request";

export default function adminChangeNewsState(id,state) {
    return request({
        url: `/news/agencyChangeNewsState/`+id+`/`+state,
        method: 'get',
    })
}
